import $ from 'jquery';

$('.share-links .links .button').on('click', function () {
	$(this).parent().find('.links-list').slideToggle();
});
